import { render, staticRenderFns } from "./LawProfessionalInvestigationRegionForm.vue?vue&type=template&id=c0644cc4&"
import script from "./LawProfessionalInvestigationRegionForm.vue?vue&type=script&lang=js&"
export * from "./LawProfessionalInvestigationRegionForm.vue?vue&type=script&lang=js&"
import style0 from "./LawProfessionalInvestigationRegionForm.vue?vue&type=style&index=0&id=c0644cc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports